import 'whatwg-fetch'

export const postData = async function (url = '', data = {}) {
  const response = await fetch(url, {
    method: 'POST',
    body: data
  })
  return await response.json()
}

